var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@chakra-ui/react";
function ApplyButton(_a) {
    var label = _a.label, applyUrl = _a.applyUrl;
    return (_jsx(Button, __assign({ variant: "ApplyButton", asChild: true, tabIndex: 0 }, { children: _jsx("a", __assign({ href: applyUrl, target: "_blank", rel: "nofollow noreferrer" }, { children: label })) })));
}
export { ApplyButton };
